import type { ESignFormStatusData } from 'features/Procedure/state/procedure-api.type'

export const DEFAULT_ESIGN_PIN_LENGTH = 3

export const ENCOUNTER_ESIGN_COPY =
  'Checking the lock checkbox will prevent any further edits on any forms in this encounter.'

export const DEFAULT_ESIGN_COPY =
  'Signing this form will prevent any further edits to this record.'

const toRecord = (value: unknown): Record<string, unknown> | null => {
  if (!value || typeof value !== 'object') {
    return null
  }

  return value as Record<string, unknown>
}

const resolveMessageValue = (value: unknown): string | null => {
  if (typeof value === 'string' && value.trim().length > 0) {
    return value.trim()
  }

  if (Array.isArray(value)) {
    const firstMessage = value.find((item) => typeof item === 'string' && item.trim().length > 0)
    return typeof firstMessage === 'string' ? firstMessage.trim() : null
  }

  return null
}

export const resolveESignPinLength = (eSignStatus?: ESignFormStatusData): number => {
  const pinLength = eSignStatus?.pin_settings?.pin_length

  if (typeof pinLength === 'number' && pinLength > 0) {
    return pinLength
  }

  return DEFAULT_ESIGN_PIN_LENGTH
}

export const resolveESignErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const directMessage = resolveMessageValue(error)

  if (directMessage) {
    return directMessage
  }

  const errorRecord = toRecord(error)
  const errorDataRecord = toRecord(errorRecord?.data)

  const responseMessage =
    resolveMessageValue(errorRecord?.data) ??
    resolveMessageValue(errorDataRecord?.message) ??
    resolveMessageValue(errorRecord?.message)

  return responseMessage || fallbackMessage
}
